import React, { useEffect, useState } from "react";
import { AutoComplete } from "@gw/web-basic-components";
import type { ColAutoCompleteProps, ColOptionsResponse } from "./dto";

/**
 * 列头搜索-自动完成组件
 */
const ColAutoComplete = (props: ColAutoCompleteProps) => {
  const { val, setVal, requestConfig, colIndex } = props;
  const { apis, useRequest } = props.configProvider;

  const [options, setOptions] = useState([]);

  const [, fetchOptions] = useRequest<any, ColOptionsResponse>(
    apis[requestConfig?.apiName || props.tableName][
      requestConfig?.fetchName || "alternatives"
    ]
  );
  /**
   * 构建自动完成选项
   */
  const handleSearchOption = async () => {
    const params = {
      type: requestConfig?.changeType || colIndex,
      query: val,
      ...(props.extraParam && props.extraParam),
    };
    const res = await fetchOptions(params);
    let newRes = [];
    if (requestConfig?.optionLabel || requestConfig?.optionValue) {
      newRes = res.dataList.map((m) => {
        const newItem = { ...m };
        if (requestConfig?.optionLabel) {
          newItem["label"] = m[requestConfig.optionLabel];
        }
        if (requestConfig?.optionValue) {
          newItem["value"] =
            m[requestConfig.optionValue] ||
            m["value"][requestConfig.optionValue];
        }
        return newItem;
      });
    } else {
      const resSet = new Set(res.dataList.map((m) => m.value));
      resSet.forEach((m) => {
        newRes.push({ value: m });
      });
    }
    setOptions(newRes.length ? newRes : res.dataList);
  };

  /**
   * 获取备选项时节流
   */
  useEffect(() => {
    if (!props.showOptions) return;
    const timer = setTimeout(() => {
      if (val) handleSearchOption();
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, [val]);

  return (
    <AutoComplete
      size="small"
      onSelect={(e) => setVal(e)}
      onSearch={setVal}
      style={{ width: "100%" }}
      backfill
      value={val}
      options={options}
      dropdownClassName={"col_search"}
      filterOption={(inputValue, option) => {
        return (
          (option!.value + "")
            ?.toUpperCase()
            ?.indexOf(inputValue.toUpperCase()) !== -1
        );
      }}
    />
  );
};

export default ColAutoComplete;
